import Vue from 'vue'
import TutorialVideoDialog from '@/components/tutorial/TutorialVideoDialog.vue'
import TutorialFluxoDialog from '@/components/tutorial/TutorialFluxoDialog.vue'
import { findTutoriais } from '@/config/tutoriais.config'

const DialogConstructor = Vue.extend(TutorialVideoDialog)
const FluxoDialogConstructor = Vue.extend(TutorialFluxoDialog)

// Instância única de cada dialog para todo o ciclo de vida da aplicação.
// Criada na primeira chamada e reutilizada nas seguintes (padrão singleton).
let instance = null
let fluxoInstance = null

function getInstance() {
  if (!instance) {
    // Monta o dialog diretamente no <body> em vez de dentro de um componente pai.
    // Isso evita problemas de z-index e overflow:hidden herdados de elementos ancestrais,
    // que são comuns quando dialogs Vuetify ficam aninhados em componentes com position relativa.
    const el = document.body.appendChild(document.createElement('div'))
    instance = new DialogConstructor({ vuetify: getVuetify() }).$mount(el)
  }
  return instance
}

function getFluxoInstance() {
  if (!fluxoInstance) {
    const el = document.body.appendChild(document.createElement('div'))
    fluxoInstance = new FluxoDialogConstructor({ vuetify: getVuetify() }).$mount(el)
  }
  return fluxoInstance
}

// Injeta a instância do Vuetify já configurada no app para que o dialog
// herde o tema (cores, dark mode) e os componentes registrados globalmente.
function getVuetify() {
  try {
    return require('@/plugins/vuetify').default
  } catch {
    return undefined
  }
}

const TutorialPlugin = {
  install(Vue) {
    // Expõe this.$tutorial em todos os componentes do app
    Vue.prototype.$tutorial = {
      // Abre o dialog com os tutoriais do path informado.
      // Não faz nada se não houver vídeo mapeado para o path.
      abrir(path) {
        const lista = findTutoriais(path)
        if (!lista || !lista.length) return
        getInstance().abrir(lista)
      },

      // Abre o player direto com uma lista de tutoriais informada manualmente,
      // sem depender do path da rota atual (usado pelo diagrama de fluxo de trabalho).
      abrirLista(lista) {
        if (!lista || !lista.length) return
        getInstance().abrir(lista)
      },

      // Abre o diagrama interativo do Ciclo Mensal de Resultados e Reuniões.
      abrirFluxo() {
        getFluxoInstance().abrir()
      },
    }
  },
}

export default TutorialPlugin
